import React from 'react';
import { Accordion, Button, Modal } from 'semantic-ui-react';

class ModalError extends React.Component<{
    mensaje: string;
    detalles: Array<string>;
    alCerrar(): void;
}> {
    public render() {
        const { alCerrar } = this.props;
        return (
            <Modal
                open
                dimmer='blurring'
                size='tiny'
                onClose={alCerrar}
                closeOnDimmerClick
                closeOnEscape
            >
                <Modal.Header>Ocurrió un error</Modal.Header>
                <Modal.Content>
                    <p>{this.props.mensaje}</p>
                    {this.props.detalles.length > 0 && (
                        <Accordion
                            panels={[
                                {
                                    key: 'detalles',
                                    title: 'Más detalles',
                                    content: this.props.detalles.join('\n'),
                                },
                            ]}
                        />
                    )}
                </Modal.Content>
                <Modal.Actions>
                    <Button content='Cerrar' onClick={this.props.alCerrar} />
                </Modal.Actions>
            </Modal>
        );
    }
}

export default ModalError;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/comun/ModalError.tsx